import React from 'react';
import {
  RiskButton,
  RiskButtonRemove,
  RiskCard,
  SelectFirstNotice,
} from './v2/ResultSlotCard.styles';
import QuotationCardResult from '../../../reusable/QuotationCardResult';
import RiskCardSelected from '../Cards/RiskCardSelected';

function ResultPageModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
  title,
  selectFirstLabel,
  wrapMainInCol = false,
  riskRowCompanyGate = false,
  excludedCompanyIds = null,
  showRiskRemoveButtons = true,
}) {
  const mainQuote = processingQuote !== null && type.id === 'res_civile' && (
    <QuotationCardResult
      processingQuote={processingQuote}
      requestInfo={insuranceRequest}
    />
  );

  const riskRemoveButtons = showRiskRemoveButtons && riskQuotations
    && riskQuotations[type.id] !== undefined
    && riskQuotations[type.id].map((quote, idx) => (
      <React.Fragment key={idx}>
        {type.id === quote.quote_type && (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeItemFromCart(quote.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        )}
      </React.Fragment>
    ));

  const addRiskButton = riskQuotations
    && riskQuotations[type.id] === undefined
    && processingQuote !== null
    && type.id !== 'res_civile' && (
      <RiskButton
        className="btn btn-success"
        data-bs-toggle="modal"
        data-bs-target={`#${type.id}`}
      >
        Aggiungi
      </RiskButton>
  );

  const buttonRowGateOpen = excludedCompanyIds === null
    || (processingQuote && !excludedCompanyIds.includes(processingQuote.company_id));

  return (
    <RiskCard
      className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${insuranceRequest.processing_quotation_id === null
        && type.id !== 'res_civile'
        ? 'bg-secondary bg-opacity-25'
        : ''
      } ${insuranceRequest.processing_quotation_id !== null
          && type.id === 'res_civile'
        ? 'bg-success bg-opacity-25'
        : ''
      } ${riskQuotations && riskQuotations[type.id] !== undefined
        ? 'bg-success bg-opacity-25'
        : ''
      }`}
    >
      <div className="me-auto">
        <h5>{title ?? type.name}</h5>
      </div>

      {wrapMainInCol ? mainQuote && <div className="col-12 mb-2">{mainQuote}</div> : mainQuote}

      {riskQuotations
        && riskQuotations[type.id] !== undefined
        && riskQuotations[type.id].map((quote, idx) => (
          <React.Fragment key={idx}>
            {processingQuote !== null
              && (!riskRowCompanyGate || processingQuote.company_id !== 2)
              && type.id === quote.quote_type && (
                <div className="col-12 mb-2">
                  <RiskCardSelected
                    quote={quote}
                    requestInfo={insuranceRequest}
                    type={type}
                  />
                </div>
            )}
          </React.Fragment>
        ))}

      <div className="d-flex justify-content-end ms-auto gap-2 mt-2">
        {buttonRowGateOpen && (
          <>
            {riskRemoveButtons}
            {addRiskButton}
          </>
        )}

        {insuranceRequest.processing_quotation_id === null
          && type.id !== 'res_civile' && (
            <SelectFirstNotice>
              {`Seleziona Prima ${selectFirstLabel}`}
            </SelectFirstNotice>
        )}

        {type.id === 'res_civile' && (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${type.id}`}
          >
            Aggiungi
          </RiskButton>
        )}

        {processingQuote !== null && (
          <>
            {type.id === 'res_civile' && (
              <RiskButtonRemove
                className="btn btn-danger"
                onClick={() => removeItemFromCart(processingQuote.id)}
              >
                Rimuovi
              </RiskButtonRemove>
            )}
          </>
        )}
      </div>
    </RiskCard>
  );
}

export default ResultPageModalButtons;
